import { render, staticRenderFns } from "./Servizi.vue?vue&type=template&id=0ca5398c"
import script from "./Servizi.vue?vue&type=script&lang=js"
export * from "./Servizi.vue?vue&type=script&lang=js"
import style0 from "./Servizi.vue?vue&type=style&index=0&id=0ca5398c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports